import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import { ReactComponent as TemplateIcon } from "assets/images/icons/Template.svg";
import { ReactComponent as ImportIcon } from "assets/images/icons/Import.svg";
import testIds from "constants/testIds";
import { ImportRequestTypes } from "constants/";

interface IHeaderActionsProps {
  isOffPlatformShipment?: boolean;
  isQuoteRequest: boolean;
  isQuickRequest?: boolean;
  onOpenTemplate: () => void;
}

function getImportType(isOffPlatformShipment?: boolean, isQuoteRequest?: boolean) {
  if (isOffPlatformShipment) {
    return ImportRequestTypes.TRACKING;
  }
  if (isQuoteRequest) {
    return ImportRequestTypes.QUOTE;
  }
  return ImportRequestTypes.QUICK;
}

function HeaderActions({ isOffPlatformShipment, isQuoteRequest, isQuickRequest, onOpenTemplate }: IHeaderActionsProps) {
  const intl = useIntl();

  return (
    <div className="d-flex align-items-center">
      {!isOffPlatformShipment && (
        <div className="cursor-pointer">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 0 }}
            overlay={
              <Tooltip id="bottom-tooltip">
                {intl.formatMessage({
                  id: "quote-request.loadTemplate",
                  defaultMessage: "Load Template",
                })}
              </Tooltip>
            }
          >
            <TemplateIcon data-testid={testIds.FORM_OPEN_TEMPLATE_DIALOG_BUTTON} onClick={onOpenTemplate} className="mr-2" />
          </OverlayTrigger>
        </div>
      )}
      {/* TODO: BUG-1725: Remove condition once quote and quick requests imports are fixed */}
      {!isQuoteRequest && !isQuickRequest && (
        <Link to={`/imports?import_type=${getImportType(isOffPlatformShipment, isQuoteRequest)}`} className="cursor-pointer">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 0 }}
            overlay={
              <Tooltip id="bottom-tooltip-export">
                {intl.formatMessage({
                  id: "quote-request.importRequest",
                  defaultMessage: "Import request",
                })}
              </Tooltip>
            }
          >
            <ImportIcon />
          </OverlayTrigger>
        </Link>
      )}
    </div>
  );
}

export default HeaderActions;
